<ion-toolbar>
  <ion-buttons slot="start">
    <ion-button fill="outline" type="button" color="secondary" (click)="close()">
      <ion-icon name="arrow-back"></ion-icon>
      <span class="hidden-md">&nbsp; {{ 'ACTION.back' | translate }}</span>
    </ion-button>
  </ion-buttons>
  <ion-title role="heading" aria-level="2">Add To Balance</ion-title>
</ion-toolbar>

<ion-content>

  @if (disconnected) {
    <div class="offline">
      <p>{{ 'LABEL.youAreOffline'| translate }}</p>
      <p>{{ 'CREDIT_CARDS.offline' | translate }}</p>
    </div>
  }

  <form class="payment-form" [formGroup]="form" id="creditCardForm" (submit)="submitForm()">

    <!-- Step 1: Amount -->
    <div class="step step1" [ngClass]="{ 'completed': currentStep > 1 }">

      <h3>
        @if (currentStep === 1) {
          <span class="step-number">1</span>
        }
        @if (currentStep !== 1) {
          <span class="step-number">
            <ion-icon name="checkmark-outline"></ion-icon>
          </span>
        }
        {{ 'CREDIT_CARDS.amount' | translate }}
        @if (currentStep !== 1) {
          <span>{{ form.controls.amount.value | currency }}</span>
        }
      </h3>
      @if (currentStep === 1) {
        <div class="step-fields">
          <table>
            <tbody>
              <tr>
                <th>{{ 'LABEL.rideFare' | translate }}</th>
                <td>{{ calculateRiderFare(baseJob) | currency }}</td>
              </tr>
              @if (features.fareAdditionalPassengers) {
                <tr>
                  <th>{{ 'LABEL.additionalPassengerFare' | translate }}</th>
                  <td>{{ calculateAdditionalFare(baseJob) | currency}}</td>
                </tr>
              }
            </tbody>
            <tfoot>
              <tr>
                <th>{{ 'LABEL.total' | translate }}</th>
                <td>{{ calculateJobFare(baseJob) | currency }}</td>
              </tr>
            </tfoot>
          </table>
          @if (calculateJobFare(baseJob) < creditCardMin) {
            <p class="min-warning">
              {{ 'CREDIT_CARDS.minimumPayment' | translate }} {{ creditCardMin | currency }}
            </p>
          }
          <div class="field">
            <ion-item>
              <ion-label id="amountLabel" position="stacked">{{ 'CREDIT_CARDS.amount' | translate }}</ion-label>
              <app-currency
                [placeholder]="'CREDIT_CARDS.amount' | translate"
                formControlName="amount"
                required
                ariaLabelledBy="amountLabel"
                aria-describedby="amountError"
                >
                <currency-start>$</currency-start>
              </app-currency>
            </ion-item>
            <form-error name="amount" id="amountError"></form-error>
          </div>
          <div class="actions">
            <ion-button
              type="button"
              color="primary"
              fill="solid"
              size="small"
              (click)="next({ increment: 1 })"
              [disabled]="form.controls.amount.invalid || disconnected"
              >
              {{ 'ACTION.next' | translate }}
            </ion-button>
          </div>
        </div>
      }
    </div>

    <!-- Step 2: Credit card fields -->
    <div class="step step2">
      <h3><span class="step-number">2</span> {{ 'CREDIT_CARDS.creditCardDetails' | translate }} </h3>
      @if (currentStep === 2 && !scriptLoaded) {
        <div class="step-fields">
          <div class="loading">
            <div class="number"><ion-skeleton-text  [animated]="!prefersReducedMotion" style="width: 100%;"></ion-skeleton-text></div>
            <div class="cvv"><ion-skeleton-text     [animated]="!prefersReducedMotion" style="width: 100%;"></ion-skeleton-text></div>
            <div class="date"><ion-skeleton-text    [animated]="!prefersReducedMotion" style="width: 100%;"></ion-skeleton-text></div>
            <div class="zip"><ion-skeleton-text     [animated]="!prefersReducedMotion" style="width: 100%;"></ion-skeleton-text></div>
          </div>
        </div>
      }
      @if (currentStep === 2) {
        <div class="step-fields" [ngClass]="{ hidden: !scriptLoaded }">
          <fieldset>
            <legend>{{ 'CREDIT_CARDS.creditCardDetails' | translate }}</legend>
            <div class="field">
              <ion-item class="cc-field" [ngClass]="{ 'has-error': fieldErrors.ccnumber, 'in-focus': inFocus.ccnumber, 'pristine': !touched.ccnumber }">
                <ion-label #ccnumberLabel position="stacked">{{ 'CREDIT_CARDS.cardNumber' | translate }}</ion-label>
                <div id="ccnumber"></div>
              </ion-item>
              @if (fieldErrors.ccnumber) {
                <ion-text role="alert" class="error" color="danger">{{ fieldErrors.ccnumber }}</ion-text>
              }
            </div>
            <div class="exp-ccv">
              <div class="field">
                <ion-item class="cc-field"  [ngClass]="{ 'has-error': fieldErrors.ccexp, 'in-focus': inFocus.ccexp, 'pristine': !touched.ccexp }">
                  <ion-label #ccexpLabel position="stacked">{{ 'CREDIT_CARDS.expirationDate' | translate }}</ion-label>
                  <div id="ccexp"></div>
                </ion-item>
                @if (fieldErrors.ccexp) {
                  <ion-text role="alert" class="error" color="danger">{{ fieldErrors.ccexp }}</ion-text>
                }
              </div>
              <div class="field">
                <ion-item class="cc-field" [ngClass]="{ 'has-error': fieldErrors.cvv, 'in-focus': inFocus.cvv, 'pristine': !touched.cvv }">
                  <ion-label #cvvLabel position="stacked">{{ 'CREDIT_CARDS.cvv' | translate }}</ion-label>
                  <div id="cvv"></div>
                </ion-item>
                @if (fieldErrors.cvv) {
                  <ion-text role="alert" class="error" color="danger">{{ fieldErrors.cvv }}</ion-text>
                }
              </div>
            </div>
          </fieldset>
          <div class="field">
            <ion-item>
              <ion-input
                [label]="'CREDIT_CARDS.zipCode' | translate"
                labelPlacement="stacked"
                [placeholder]="'00000' | translate"
                type="text"
                formControlName="ccZip"
                required
                aria-describedby="zipCodeError"
                inputmode="numeric"
              ></ion-input>
            </ion-item>
            <form-error name="ccZip" id="zipCodeError" [customMessage]="{ pattern: zipCodeError }"></form-error>
          </div>
        </div>
      }
    </div>

  </form>
</ion-content>

<ion-toolbar class="bottom-actions">
  <ion-button type="submit" form="creditCardForm" fill="solid" expand="block" [disabled]="form.invalid || !ccIsValid || disconnected || submitting">
    {{ 'ACTION.add' | translate }} {{ form.controls.amount.value && form.controls.amount.valid ? (form.controls.amount.value | currency) : '' }} {{ 'CREDIT_CARDS.toBalance' | translate }}
  </ion-button>
  <ion-button type="button" fill="outline" expand="block" (click)="close()" [disabled]="submitting">
    {{ 'ACTION.cancel' | translate }}
  </ion-button>
</ion-toolbar>
